import {
  CurrentMindfulMinuteQuery,
  CurrentMindfulMinuteQueryVariables,
  MindfulMinuteEntity,
  MindfulMinutePage,
  MindfulMinutePageQuery,
} from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_CURRENT_MINDFUL_MINUTE, QUERY_MINDFUL_MINUTE_PAGE } from '@/graphql/queries/daily/midful-minute';
import { MUTATION_UPDATE_USER_TRACKING } from '@/graphql/mutations/on-boarding/user';
import { getAuthentication } from '@/hooks/useAuthentication';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<MindfulMinutePageQuery>({
      query: QUERY_MINDFUL_MINUTE_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.mindfulMinutePage?.data?.attributes as MindfulMinutePage,
    error,
  };
};

export const getMindfulMinute = async () => {
  const apolloClient = initializeApollo();

  const now = new Date();
  const date = now.toISOString().split('T')[0];

  const { data } = await requestHandler(
    apolloClient.query<CurrentMindfulMinuteQuery, CurrentMindfulMinuteQueryVariables>({
      query: QUERY_CURRENT_MINDFUL_MINUTE,
      variables: {
        date: {
          eq: date,
        },
      },
      fetchPolicy: 'cache-first',
    }),
  );
  return data?.mindfulMinutes?.data[0] as MindfulMinuteEntity;
};

export async function onChangeOnboardStatus() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate({
      mutation: MUTATION_UPDATE_USER_TRACKING,
      variables: {
        id: getAuthentication()?.user?.id,
        input: {
          onboardMindfulMinuteCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}
